import React from "react";
import { useSelector } from "react-redux";
import BlogCard from "./BlogCard";

const BlogList = () => {
  const blogsData = useSelector((state) => state.blogs);
  const filterState = useSelector((state) => state.filters);

  const filterByCategories = (data) => {
    if (filterState.category.length > 0) {
      return filterState?.category?.includes(data?.category);
    } else return true;
  };

  const filterByAuthor = (data) => {
    if (filterState.author.length > 0) {
      return filterState?.author === data?.author;
    } else return true;
  };

  const filterBySearchText = (data) => {
    if (filterState.searchText.length > 0) {
      const title = data?.title?.toLowerCase();
      const searchText = filterState?.searchText?.toLowerCase();
      return title.includes(searchText);
    } else return true;
  };

  return (
    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
      {blogsData
        ?.filter(filterByAuthor)
        ?.filter(filterByCategories)
        ?.filter(filterBySearchText)
        ?.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
    </div>
  );
};

export default BlogList;
